import axios from "axios";
import {POST_MESSAGE} from "../routes";

export default {
    async create(data, options = {}) {
        return await axios.post(POST_MESSAGE, data, options);
    },
}
